// npm imports
import { Toastr } from "@revvsales/components";

import { updateSection } from "../actions/DocumentActions/index";
import BaseCommand from "./baseCommand";
import { DOCUMENT_COMPONENT_TYPES } from "../constants/document";

const DOCUMENT = "DOCUMENT";

class UpdateComponentCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
    this.unDoable = this.componentData.unDoable !== false;
  }

  execute() {
    if (this.isRedo && this.componentData.oldSection.id) {
      this.redo();
    } else {
      const {
        mode,
        isTemplateTypeForm,
        components,
        oldSection,
        isMouseHover,
        clickedActiveComponentId,
        clickedSection,
        updatedSection,
        updateDocumentComponentAction,
        updateSectionService,
        addedNewTextSection,
        change,
      } = this.componentData;

      if (!isMouseHover && oldSection) {
        // Store current doc sections as a snapshot first then execute the below actions
        if (oldSection.type === "Table") {
          oldSection.updatedComponentId = clickedActiveComponentId;
          oldSection.clickedSection = clickedSection;
        }
      }

      const componentStatus = Object.keys(components).includes(
        updatedSection.id,
      );

      // check if the updatedSection nis available or not
      if (!componentStatus) {
        return null;
      }

      if (!isMouseHover && (change === undefined || change === true)) {
        if (isTemplateTypeForm && mode === DOCUMENT) {
          updateSectionService(updatedSection).then(response => {
            updatedSection.form_field = response.content.form_field || [];
            if (updatedSection.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
              this.componentData.toggleCoverpageView(true);
            }
            updateDocumentComponentAction(updatedSection, addedNewTextSection);
          });
        } else {
          // Update redux first then make service call to avoid flicker issue
          updateDocumentComponentAction(updatedSection, addedNewTextSection);
          updateSectionService(updatedSection)
            .then(() => {})
            // Update redux with old data if service call fails
            .catch(() => {
              updateDocumentComponentAction(oldSection);
              Toastr.showToastr({
                type: "failure",
                message: "Oops, Something went wrong!!",
                timeout: 3000,
              });
            });
        }
      } else if (change === null) {
        updateDocumentComponentAction(updatedSection, addedNewTextSection);
      }
    }
    return null;
  }

  undo() {
    const {
      mode,
      components,
      layout: newLayout,
      forceUpdateEditorSectionIdAction,
      updatedSection,
    } = this.componentData;

    let { oldSection: section } = this.componentData;

    // Scroll section into view when do Undo
    if (section) {
      this.scrollIntoView(section.id);
    }

    const updatedComponent = {};
    const editorPayload = {};
    const newComponents = { ...components };

    if (
      (updatedSection.type === "CoverPage" ||
        updatedSection.type === "HeaderFooter") &&
      (section.oldCoverpageComponent || section.oldHeaderFooterComponent)
    ) {
      section = section.oldCoverpageComponent
        ? section.oldCoverpageComponent.content
        : section.oldHeaderFooterComponent.content;
    }

    updateSection(mode)(section);

    newComponents[section.id] = {
      ...newComponents[section.id],
      content: section,
    };
    if (section.type === "Image") {
      updatedComponent.data = section.data;
      editorPayload.id = section.id;
    } else if (section.type === "HTML") {
      updatedComponent.id = section.id;
      updatedComponent.type = section.type;
      editorPayload.editorState = section.currentContent || section.data;
      editorPayload.section = section;
      editorPayload.id = section.id;
    } else if (section.type === "Table") {
      if (section.clickedSection) {
        updatedComponent.id = section.updatedComponentId;
        updatedComponent.type = section.type;
        updatedComponent.hoveredActiveComponentId = section.id;
        editorPayload.editorState =
          section.clickedSection.currentContent || section.clickedSection.data;
        editorPayload.section = section;
        editorPayload.id = section.clickedSection.id;
      }
    } else if (
      (section.type === "CoverPage" || section.type === "HeaderFooter") &&
      this.componentData.oldSection
    ) {
      const { oldSection } = this.componentData;
      if (oldSection.type === "HTML") {
        updatedComponent.id = oldSection.id;
        updatedComponent.type = oldSection.type;
        editorPayload.editorState =
          oldSection.currentContent || oldSection.data;
        editorPayload.section = oldSection;
        editorPayload.id = oldSection.id;
      } else if (oldSection.type === "Table") {
        if (oldSection.clickedSection) {
          updatedComponent.id = oldSection.updatedComponentId;
          updatedComponent.type = oldSection.type;
          updatedComponent.hoveredActiveComponentId = oldSection.id;
          editorPayload.editorState =
            oldSection.clickedSection.currentContent ||
            oldSection.clickedSection.data;
          editorPayload.section = oldSection;
          editorPayload.id = oldSection.clickedSection.id;
        }
      }
    }
    if (updatedSection.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
      this.componentData.toggleCoverpageView(false);
    }
    this.componentData.undoComponentUpdate({
      layout: newLayout,
      components: newComponents,
      updatedComponentId: updatedComponent.id,
      updatedComponentType: updatedComponent.type,
      hoveredActiveComponentId: updatedComponent.hoveredActiveComponentId,
    });

    if (editorPayload.id) {
      forceUpdateEditorSectionIdAction(editorPayload.id);
    }

    if (!updatedComponent.id) {
      this.componentData.nukeEditorState(true);
    }
    this.isRedo = true;
  }

  redo() {
    const {
      mode,
      components,
      layout: newLayout,
      forceUpdateEditorSectionIdAction,
      oldSection,
    } = this.componentData;

    let { updatedSection: section } = this.componentData;

    // Scroll section into view when do Redo
    if (section) {
      this.scrollIntoView(section.id);
    }

    if (!section.id) {
      section = section.content;
    }

    updateSection(mode)(section);
    const newComponents = { ...components };
    const updatedComponent = {};

    const editorPayload = {};

    newComponents[section.id] = {
      ...newComponents[section.id],
      content: section,
    };

    if (section.type === "Image") {
      updatedComponent.data = section.data;
      editorPayload.id = section.id;
    } else if (section.type === "HTML") {
      updatedComponent.id = section.id;
      updatedComponent.type = section.type;
      editorPayload.editorState = section.currentContent || section.data;
      editorPayload.section = section;
      editorPayload.id = section.id;
    } else if (section.type === "Table") {
      if (section.clickedSection) {
        updatedComponent.id = section.updatedComponentId;
        updatedComponent.type = section.type;
        updatedComponent.hoveredActiveComponentId = section.id;
      }

      if (oldSection.clickedSection) {
        editorPayload.editorState =
          oldSection.clickedSection.currentContent ||
          oldSection.clickedSection.data;
        editorPayload.id = oldSection.clickedSection.id;
        editorPayload.section = section;
      }
    } else if (
      (section.type === "CoverPage" || section.type === "HeaderFooter") &&
      this.componentData.oldSection
    ) {
      if (oldSection.type === "HTML") {
        updatedComponent.id = oldSection.id;
        updatedComponent.type = oldSection.type;
        editorPayload.editorState =
          oldSection.currentContent || oldSection.data;
        editorPayload.section = oldSection;
        editorPayload.id = oldSection.id;
      } else if (oldSection.type === "Table") {
        if (oldSection.clickedSection) {
          updatedComponent.id = oldSection.updatedComponentId;
          updatedComponent.type = oldSection.type;
          updatedComponent.hoveredActiveComponentId = oldSection.id;
          editorPayload.editorState =
            oldSection.clickedSection.currentContent ||
            oldSection.clickedSection.data;
          editorPayload.section = oldSection;
          editorPayload.id = oldSection.clickedSection.id;
        }
      }
    }

    this.componentData.undoComponentUpdate({
      layout: newLayout,
      components: newComponents,
      updatedComponentId: updatedComponent.id,
      updatedComponentType: updatedComponent.type,
      hoveredActiveComponentId: updatedComponent.hoveredActiveComponentId,
    });

    if (editorPayload.id) {
      forceUpdateEditorSectionIdAction(editorPayload.id);
    }

    if (!updatedComponent.id) {
      this.componentData.nukeEditorState(true);
    }
    this.isRedo = false;
  }
}

export default UpdateComponentCommand;



// WEBPACK FOOTER //
// ./src/commands/updateComponentCommand.js